export const styles = {
  infoBox: {
    display: "flex",
    alignItems: "center",
    padding: "12px",
    marginBottom: "24px"
  },
  iconContainer: {
    width: "22px",
    height: "22px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "12px"
  },
  infoText: {
    lineHeight: 1.5,
    fontSize: "14px",
    color: "#212121"
  }
};
